import * as React from "react";

import { useKeyPress } from "../use-key-press";

export interface KeyboardNavigableListProps {
  myList: any[];
  canInteract: boolean;
  handleSelect: (item: any) => void;
}
export const useKeyboardNavigableList = (
  props: KeyboardNavigableListProps
): [number, React.Dispatch<React.SetStateAction<number>>] => {
  const [activeSuggestionIndex, setActiveSuggestionIndex] = React.useState(-1);

  const downPress = useKeyPress("ArrowDown");
  const upPress = useKeyPress("ArrowUp");
  const enterPress = useKeyPress("Enter");

  React.useEffect(() => {
    setActiveSuggestionIndex(-1);
  }, [props.myList]);

  React.useEffect(() => {
    if (props.canInteract && downPress) {
      setActiveSuggestionIndex((index) => {
        let newIndex = index + 1;
        if (newIndex >= props.myList.length) {
          newIndex = 0;
        }
        return newIndex;
      });
    }
  }, [props.canInteract, props.myList, downPress]);

  React.useEffect(() => {
    if (props.canInteract && upPress) {
      setActiveSuggestionIndex((index) => {
        let newIndex = index - 1;
        if (newIndex < 0) {
          if (props.myList.length > 0) {
            newIndex = props.myList.length - 1;
          } else {
            newIndex = 0;
          }
        }
        return newIndex;
      });
    }
  }, [props.canInteract, props.myList, upPress]);

  const handleSuggestionChosen = React.useCallback(
    (itemFromMyList: any) => {
      props.handleSelect(itemFromMyList);
    },
    [props.handleSelect]
  );
  React.useEffect(() => {
    if (
      props.canInteract &&
      enterPress &&
      props.myList.length > activeSuggestionIndex
    ) {
      let suggestionIndex = activeSuggestionIndex;
      if (activeSuggestionIndex < 0) {
        suggestionIndex = 0;
      }
      const suggestion = props.myList[suggestionIndex];
      handleSuggestionChosen(suggestion);
    }
  }, [
    props.canInteract,
    enterPress,
    props.myList,
    activeSuggestionIndex,
    handleSuggestionChosen,
  ]);

  return [activeSuggestionIndex, setActiveSuggestionIndex];
};
